<template>
  <div id="center" class="clearfix" style="min-height: 246px">
    <div id="left-menu" class="pull-left">
      <i class="iconfont m-show-btn mhide"></i>

      <div class="menu-wrap">
        <i class="iconfont close-leftmenu-btns mhide"></i>
        <div class="t-user t-teacher-box">
             <img
            :src="this.$store.state.headPortrait"
            onerror="this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAE90lEQVRogdWbTWgdVRTHf3PfVxbWCFahRoTulFJELRVLrc8aFy5trYW6luLHtttSu5SCC7Eu3IpiStuVaBfamlaCUkF4dmtBqmIwJa2FfMybuS5O7nSSzJt5M/fMS/KDLPLevHPPf+73OfcGCwsL1MQ48AKwB9gF7AQmgIeAB1aeuQfMA38BvwM3gOvADHCnDqcCZcGPA0eBQ8DzQKOinQj4CbgAnAP+UPEOPcEHgBPAa1QXOYgI+AY4A/zga8xXcBc4Dbzo68iQXAVOAleqGjAVf7cD+By4zOjEslLW5ZWyd1QxUKWGjwCfIYPSRnIHeBvp40NTpobbwMfAFBsvFsSHKcSnzrA/GraGtwEXgVcquVY/08DrwO2iB4ep4UeQfrNZxYLMEt8jvuZSJHgc+BZ4TsGpunkauERBd8sT3EYm/mcVnaqbZxCf24MeyBP8EXBQ26MRcBDxPZNBg9YRZATcyhwlQ0OW4AngN2SRr0Icx8mftRZrrRQeBAAYYwiCgEajkXymwDywG7iV/jBL8AVkiC9NFEWJKEda4DAYY2g0GjQaKkvyi8hGJmGt4JeR4b0Si4uLVX+6DmMMrVZLo8Ynge8Su2u+PO1jWbE5Escxy8vLpVrHAE6l/0kLPgDs97GsKRikOyiI3o9oA1YLPuFjNQxD4jj2MZGJtZZ+v+9rJtHm+vCjwJ9As4o11/zqpNPp+LSgPjL7zLoaPkZFsUAtNatcRhPRmDTpw74O1Y3CSz0M0qTHgTk8YlFhGBJFka9DuRhjaLcHLpGHIQIeNsA+PANv2qNzTWU0gH2GLbIbUnqpewyy3vRii9QwwC6DZAS82EKCdxrgMV8rCsu/QpSmvgmD5zYwjmPCMNRwJpd+v68h+kHD/cTWpkehJW2rmnnYEBT68bJBUpYb6cQouWeQUEhlRinYGO8G+Z9BktEb7cioyvjHADd9rTSbzVprOggCms3Km7k0Nw0SofTCGEOn06mlppVt3zDALxqWAK1I4yqUX+J1le1hmqWlJdWVl2ekI00EbDdIYnlGwyJAq9XSMqUVpnXMAPOuvZzXsuo26r6ONptN7S5yHpSCeFlYa4miqHTE0Y3IymLXBfFmkdyqGs7xsbGxoWs7CAI6nU4dg98lROOquPSH2qVsIhJtacHTwLU6SitTwzVwDdEGrM8tndIsyVpbKiPh9tbKce4P0v+opksdURQlqdOquHyxZ864MF0KckC0R8lISBzHiVBtXM7YJc6HJDMhnjUN3QKOA1/lWUsnv+tOtbjTAyA1b4xJXkIOx1kjFvIPpp0F3kl/4ObWKIpGErgrwjX7jJ3Up8C7mb/JEdxG5q8u3B9QNoPQtQRBQKvVchuNaeBVIDOdmbcVWQbeAHqK2fhacInzOI57yCA1MHdbtPeas9ZOhmH4q6qH9dALw3DSWjuX91DhZrPf789aa19CzltuVq4CXWvtbNHaPVewG6SAu8jx/k+0PFTkLNJnbwOFA2qu4DXTzRLwPvAmNd04KcldxJf3EN8S8qbJMoId54CngC/KeqjIl8CTDDgNry0Y4G/gLeQgWy0bjgH8iBwePbbiQyaVBQ8xDV1BLl50ga+BOpZc8YrtLnLmqnDwzPM79wpAhYDcE0i/OgTsxe+i1s/IRmaKkhe1XCAh87s8wS5EU3HBkb6KtxtJvG8n+yrev0hCoIfnVbyiENH/d4LwXx+Ezr4AAAAASUVORK5CYII='"
            width="36"
            height="36"
          /><span class="center-name">{{this.$store.state.userName}}</span>
          <!--../assets/image/user.png-->
          <!-- <span class="center-auth auth-2">未认证</span> -->
        </div>
        <ul class="my-left">
          <li class="m-li1">
            <i class="iconfont icon-wode"></i
            ><router-link to="/teachersPersonalCenter">我的信息</router-link>
          </li>
          <li class="m-li2">
            <i class="iconfont icon-chugui2"></i>
            <router-link to="/personalCenterChangePasswords">修改密码</router-link>
          </li>
          <li class="m-li3 cur">
            <i class="iconfont icon-star-hollow"></i>
            <router-link to="/myCollection">我的收藏</router-link>
          </li>

          <li class="m-li4">
            <i class="iconfont icon-555"></i>

            <router-link to="/myComments">我的评论</router-link>
          </li>

          <li class="m-li8">
            <i class="iconfont icon-555"></i>

            <router-link to="/myExperiment">我的实验</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div id="content" class="pull-right">
      <div class="center_content" style="min-height: 575.6px">
        <div class="content-wrap clearfix">
          <ul id="list" class="clearfix">
            <li v-for="(item, index) in collectTheData" :key="index">
              <img
                :src="theDefaultImage(item.eduPrProject.cover)"
                onerror="this.src='data:image/jpeg;base64,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'"
                width="147"
                height="100"
                @click="clickOnTheCourse(item.courseId)"
              />
              <div class="res-ctn">
                <h1 class="title">
                  <a @click="clickOnTheCourse(item.courseId)">{{
                    item.eduPrProject.projectName
                  }}</a>
                </h1>
                <div class="res-action">
                  <span class="c-date">{{ ccc(item.eduPrProject.createTime) }}</span
                  ><span class="c-delete" @click="clickCancelCollection(item.courseId)"
                    >取消收藏</span
                  >
                </div>
              </div>
            </li>
            <div class="noitems" v-show="collectTheNumber==0">暂无收藏</div>
          </ul>
          <!-- <ul id="pagination" class="cN-pagination">
            <li class="selected">1</li>
            <span class="page_total">共<b>3</b>条</span
            ><span class="page_goto"
              ><input
                class="page"
                id="page-num"
                onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
              /><span class="go-page" id="go-page">GO</span></span
            >
          </ul> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import {
  personalInformationQuery,
  afterTheLoginAccessPermissions,
  loginAccessToTheMenu,
  myCollection,
  deleteTheCollection,
} from "../assets/api/index";
import router from "../router/index.js";
import { ElMessage } from "element-plus";
import url from "../assets/js/config.js";
export default {
  setup() {
    const tableData = ref([]);
    const theLoginRequest = reactive({
      userId: null,
    });

    const collectTheRequest = reactive({
      uid: null,
    });
    const getStatusInformation = reactive([]);
    const provincialData = ref([]);
    const getData = () => {
      personalInformationQuery(theLoginRequest).then((res) => {
        tableData.value = res.data;
        provincialData.value = JSON.parse(res.data.remark);

        getStatusInformation.value = JSON.parse(res.data.remark).indexType;
      });
    };

    //登陆后获取权限
    const afterLandingPermissionData = ref();
    const automaticallyAccessPermissions = () => {
      afterTheLoginAccessPermissions().then((res) => {
        afterLandingPermissionData.value = res.user;
        theLoginRequest.userId = res.user.userId;
        collectTheRequest.uid = res.user.userId;
        getData();
        toAutomaticallyCollect();
      });
    };
    automaticallyAccessPermissions();
    //我的收藏
    const collectTheData = ref([]);
    const collectTheNumber =ref([]);
    const toAutomaticallyCollect = () => {
      myCollection(collectTheRequest).then((res) => {
        collectTheData.value = res.rows;
        collectTheNumber.value = res.total;
      });
    };

    //登陆后获取菜单

    const automaticAccessToTheMenu = () => {
      loginAccessToTheMenu().then((res) => {});
    };
    automaticAccessToTheMenu();

    //上传图片
    const handleRemove = (file, fileList) => {
      console.log(file, fileList);
    };

    const gender = (sex) => {
      if (sex == 0) {
        return "男";
      } else {
        return "女";
      }
    };
    const ccc = (value) => {
      return value.slice(0, 10);
    };
    //默认图片
    const theDefaultImage = (value) => {
      if (value == null) {
        return require("../assets/image/listmoren.jpg");
      } else {
        return url + value;
      }
    };

    //取消收藏点击
    const cancelTheCollectionReference = reactive({
      uid: localStorage.getItem("userId"),
      courseId: null,
    });
    const clickCancelCollection = (id) => {
      cancelTheCollectionReference.courseId = id;
      deleteTheCollection(cancelTheCollectionReference).then((res) => {
        if (res.code == 200) {
          ElMessage.success("取消成功");
        } else {
          ElMessage.error(res.msg);
        }

        toAutomaticallyCollect();
      });
    };

    //课程详情
    const clickOnTheCourse = (id) => {
      localStorage.setItem("courseid", id);
      router.push("/projectDetails");
    };

    return {
      clickCancelCollection,
      theDefaultImage,
      clickOnTheCourse,
      collectTheNumber,
      tableData,
      afterLandingPermissionData,
      getStatusInformation,
      provincialData,
      collectTheData,
      cancelTheCollectionReference,
      ccc,
      url,
      toAutomaticallyCollect,
      handleRemove,
      gender,
      automaticAccessToTheMenu,
      automaticallyAccessPermissions,
      getData,
    };
  },

  name: "teachersPersonalCenter",
};
</script>

<style src="../assets/css/jiaoshi/bootstrap-v3.3.7.min.css" scoped></style>
<style src="../assets/css/jiaoshi/common.css" scoped></style>
<style src="../assets/css/jiaoshi/common1.css" scoped></style>
<style src="../assets/css/jiaoshi/form.css" scoped></style>
<style src="../assets/css/jiaoshi/laydate.css" scoped></style>
<style src="../assets/css/jiaoshi/my-collection.css" scoped></style>
<style src="../assets/css/jiaoshi/header_v5.css" scoped></style>
<style src="../assets/css/jiaoshi/pagination.css" scoped></style>

<style scoped></style>